import { expedienteMedidaService } from "@/_services";
export const expedienteMedida = {
  namespaced: true,
  state: {
    list: {
      data: [],
      status: {},
    },
    entity: {
      data: {},
      status: {},
    },
    patch: {
      data: {},
      status: {},
    },
    leido: {
      data: {},
      status: {},
    },
    excel: {
      data: {},
      status: {},
    },
    excelPartner: {
      data: {},
      status: {},
    },
  },
  mutations: {
    getExpedientesMedidasRequest(state) {
      state.list.status = {
        loading: true,
      };
    },
    getExpedientesMedidasSuccess(state, response) {
      state.list.data = response;
      state.list.status = {
        loaded: true,
      };
    },
    getExpedientesMedidasError(state, error) {
      state.list.data = null;
      state.list.status = {
        error,
      };
    },
    getExpedienteMedidaByIdRequest(state) {
      state.entity.status = {
        loading: true,
      };
    },
    getExpedienteMedidaByIdSuccess(state, response) {
      state.entity.data = response;
      state.entity.status = {
        loaded: true,
      };
    },
    getExpedienteMedidaByIdError(state, error) {
      state.entity.data = null;
      state.entity.status = {
        error,
      };
    },
    putExpedienteRequest(state) {
      state.patch.status = {
        changing: true,
      };
    },
    putExpedienteSuccess(state, response) {
      state.patch.data = response;
      state.patch.status = {
        changed: true,
      };
    },
    putExpedienteError(state, error) {
      state.patch.data = null;
      state.patch.status = {
        error,
      };
    },
    putExpedienteLeidoRequest(state) {
      state.leido.status = {
        changing: true,
      };
    },
    putExpedienteLeidoSuccess(state, response) {
      state.leido.data = response;
      state.leido.status = {
        changed: true,
      };
    },
    putExpedienteLeidoError(state, error) {
      state.leido.data = null;
      state.leido.status = {
        error,
      };
    },
    excelRequest(state) {
      state.excel.status = {
        downloading: true,
      };
    },
    excelSuccess(state, pdf) {
      state.excel.data = pdf;
      state.excel.status = {
        downloaded: true,
      };
    },
    excelError(state, error) {
      state.excel.data = null;
      state.excel.status = {
        error,
      };
    },
    excelPartnerRequest(state) {
      state.excelPartner.status = {
        downloading: true,
      };
    },
    excelPartnerSuccess(state, pdf) {
      state.excelPartner.data = pdf;
      state.excelPartner.status = {
        downloaded: true,
      };
    },
    excelPartnerError(state, error) {
      state.excelPartner.data = null;
      state.excelPartner.status = {
        error,
      };
    },
  },
  actions: {
    getExpedientesMedidas({ commit }, request) {
      commit("getExpedientesMedidasRequest");
      expedienteMedidaService
        .getExpedientesMedidas(request.pagination, request.filters)
        .then((response) => {
          commit("getExpedientesMedidasSuccess", response);
        })
        .catch((error) => {
          commit("getExpedientesMedidasError", error);
        });
    },
    getExpedienteMedidaById({ commit }, id) {
      commit("getExpedienteMedidaByIdRequest");
      expedienteMedidaService
        .getExpedienteMedidaById(id)
        .then((res) => {
          commit("getExpedienteMedidaByIdSuccess", res);
        })
        .catch((error) => {
          commit("getExpedienteMedidaByIdError", error);
        });
    },
    putExpediente({ commit }, req) {
      commit("putExpedienteRequest");
      expedienteMedidaService
        .putExpediente(req.id, req.body)
        .then((res) => {
          commit("putExpedienteSuccess", res);
        })
        .catch((error) => {
          commit("putExpedienteError", error);
        });
    },
    putExpedienteLeido({ commit }, req) {
      commit("putExpedienteLeidoRequest");
      expedienteMedidaService
        .putExpediente(req.id, req.body)
        .then((res) => {
          commit("putExpedienteLeidoSuccess", res);
        })
        .catch((error) => {
          commit("putExpedienteLeidoError", error);
        });
    },
    getExcel({ commit }, filters) {
      commit("excelRequest");
      expedienteMedidaService
        .getExcel(filters)
        .then((excel) => {
          commit("excelSuccess", excel);
        })
        .catch((error) => {
          commit("excelError", error);
        });
    },
    getExcelPartner({ commit }, filters) {
      commit("excelPartnerRequest");
      expedienteMedidaService
        .getExcelPartner(filters)
        .then((excelPartner) => {
          commit("excelPartnerSuccess", excelPartner);
        })
        .catch((error) => {
          commit("excelPartnerError", error);
        });
    },
  },
};
